import { render, staticRenderFns } from "./rizhi.vue?vue&type=template&id=9de38cc4&scoped=true&"
import script from "./rizhi.vue?vue&type=script&lang=js&"
export * from "./rizhi.vue?vue&type=script&lang=js&"
import style0 from "./rizhi.vue?vue&type=style&index=0&id=9de38cc4&scoped=true&lang=less&"
import style1 from "./rizhi.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de38cc4",
  null
  
)

export default component.exports